import { useEffect, useState } from "react";

/**
 * Object URLs for `kind === "file"` slots (e.g. console carousel). Revokes previous URLs on change/unmount.
 * @param {Array<{ id?: string, kind?: string, file?: File }>} slots
 * @returns {Record<string, string>} map slot id → blob: URL
 */
export function useBlobUrlMapForFileSlots(slots) {
  const [blobById, setBlobById] = useState({});
  useEffect(() => {
    const revokeList = [];
    const next = {};
    for (const s of slots || []) {
      if (s?.kind === "file" && s.file && s.id) {
        const u = URL.createObjectURL(s.file);
        next[s.id] = u;
        revokeList.push(u);
      }
    }
    setBlobById(next);
    return () => revokeList.forEach((u) => URL.revokeObjectURL(u));
  }, [slots]);
  return blobById;
}
